import { Component } from 'opus-angular-seed-core';
import template from './template.html';

@Component({
    bindings: {
        icon: '@',
        label: '@',
        url: '@',
        as: '@',
        disabled: '<'
    },
    template
})
export default class {}



// WEBPACK FOOTER //
// ./src/app/components/quickActionButton/index.js